// 所有组织、历史解读师选项和图片识别共用同一个模型。
export const TAROT_INTERPRETATION_MODEL = 'gpt-6.1-sol';
export const TAROT_INTERPRETER_LABEL = 'GPT 6.1 Sol';
